import { createReducer } from '@reduxjs/toolkit';
import { setFromOAuth } from './oauth.actions';

const initialState = {
  fromOAuth: false,
};

const oAuthReducer = createReducer(initialState, (builder) => {
  builder.addCase(setFromOAuth, (state) => {
    state.fromOAuth = true;
  });
});

export default oAuthReducer;
